import { mapGetters } from 'vuex';

import { modalHybrid } from '@/utils/modal-utils.js';
import { planTypes, BASE_PLAN_SUB_TYPES } from '@/common/constants.js';

export default {
  computed: {
    ...mapGetters(['getSelectedPlans']),
    isInModalCheckout() {
      return this.$context.is.modal;
    },
    isInClientModal() {
      return modalHybrid.isInWebview && this.isInModalCheckout;
    },
    isOnlyProPlanInCart() {
      return (
        this.getSelectedPlans.length === 1 &&
        this.getSelectedPlans.find((p) => p.type === planTypes.ZOOM_MEETING && p.category === BASE_PLAN_SUB_TYPES.PRO)
      );
    },
    isFreeTrialInClientModal() {
      // return !this.isInClientModal && this.$context.is.buyTrial && this.isOnlyProPlanInCart;
      return this.isInClientModal && this.$context.is.buyTrial;
    },
  },
  watch: {},
  methods: {},
};
